import cn from 'classnames';
import React from 'react';
import { useTheme } from 'styled-components';

import { useReservationProduct } from '@/components/modules/product-page/hooks/use-reservation-product';

import { TFullRentProduct, useBasketActions, useActionsProducts } from '@/entities/product';

import { useTranslate } from '@/shared/hooks/use-translate';
import { Button } from '@/shared/ui/button';
import { BasketFilledIcon, HeartIcon } from '@/shared/ui/icons';

import * as Styled from './styled';

type TControllerButtonProps = {
    product: TFullRentProduct;
};

export const LandingControlButtons: React.FC<TControllerButtonProps> = ({ product }) => {
    const theme = useTheme();

    const { t } = useTranslate();

    const { handleAddProductToFavorite, favoriteProducts } = useActionsProducts({ product });

    const { basketProducts } = useBasketActions({ product });

    const { showReservationModal, contextHolder, isDisabledReservation } = useReservationProduct({
        product,
    });

    const isFavorite = favoriteProducts?.includes(product.id);

    const isInBasket = basketProducts?.includes(product.id);

    return (
        <Styled.Wrapper>
            <Button
                className="basket-btn"
                variant="primary"
                onClick={showReservationModal}
                disabled={isDisabledReservation}
                aria-label={t('Забронировать')}
            >
                <>
                    <BasketFilledIcon color={theme.color.secondary} width="20px" />
                    <span>{t('Забронировать')}</span>
                </>
            </Button>
            <Button
                aria-label={isFavorite ? t('Убрать из избранного') : t('Добавить в избранное')}
                className={cn('fav-btn', { active: isInBasket })}
                outlined={true}
                onClick={handleAddProductToFavorite}
            >
                <>
                    <HeartIcon color={theme.color.primary} width="20px" filled={isFavorite} />
                    <span className="fav-label">
                        {isFavorite ? t('Убрать из избранного') : t('Добавить в избранное')}
                    </span>
                </>
            </Button>
            {contextHolder}
        </Styled.Wrapper>
    );
};
